var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "el-dialog",
        {
          staticClass: "bj-dialog-list",
          class: _vm.classID,
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.title,
            visible: _vm.visible,
            "before-close": _vm.handleClose,
            width: _vm.width,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "app-container goods-attribute-view-form" },
            [
              _c("BjDivider", [
                _vm._v(
                  _vm._s(_vm.$t("goodsClassify.dialogTable.BasicInformation"))
                ),
              ]),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "130px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsClassify.table.Attributename"),
                        prop: "name",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("BjFormItemCode", {
                    attrs: {
                      label: _vm.$t("goodsClassify.table.Attributecode"),
                      prop: "code",
                    },
                    model: {
                      value: _vm.form.code,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "code", $$v)
                      },
                      expression: "form.code",
                    },
                  }),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsClassify.dialogTable.Presentation"),
                        prop: "formType",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("chooseText"),
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.formType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "formType", $$v)
                            },
                            expression: "form.formType",
                          },
                        },
                        _vm._l(_vm.INPUT_BOX_TYPE_LIST, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.$t(item.label),
                              value: item.value,
                            },
                          })
                        }),
                        1
                      ),
                      _c("div", [
                        _c(
                          "span",
                          {
                            staticStyle: { "font-size": "12px", color: "#999" },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-warning-outline",
                              staticStyle: { color: "#999" },
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "goodsClassify.dialogTable.corresponding"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm.setFlag != _vm.GOODS_COMBO_TYPES.PACKAGE
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "goodsClassify.dialogTable.GenerateSKU"
                            ),
                            prop: "skuFlag",
                          },
                        },
                        [
                          _c("el-switch", {
                            attrs: {
                              disabled:
                                _vm.form.formType ===
                                _vm.INPUT_BOX_TYPE_JSON.INPUT,
                            },
                            model: {
                              value: _vm.form.skuFlag,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "skuFlag", $$v)
                              },
                              expression: "form.skuFlag",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.remarkText"),
                        prop: "remark",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.form.formType &&
                        _vm.form.formType !== _vm.INPUT_BOX_TYPE_JSON.INPUT,
                      expression:
                        "form.formType && form.formType !== INPUT_BOX_TYPE_JSON.INPUT",
                    },
                  ],
                },
                [
                  _c("BjDivider", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("goodsClassify.dialogTable.InformationContent")
                      )
                    ),
                  ]),
                  _c(
                    "el-button",
                    {
                      staticClass: "mb16",
                      attrs: { type: "primary" },
                      on: { click: _vm.addOneExecutorsConfig },
                    },
                    [_vm._v(_vm._s(_vm.$t("addText")))]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "mb16",
                      attrs: { disabled: !_vm.isSelected, type: "primary" },
                      on: { click: _vm.onDelSelected },
                    },
                    [_vm._v(_vm._s(_vm.$t("delText")))]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "mb16",
                      attrs: { disabled: !_vm.isSelected, type: "primary" },
                      on: { click: _vm.onSaveSelected },
                    },
                    [_vm._v(_vm._s(_vm.$t("saveText")))]
                  ),
                  _c(
                    "el-table",
                    {
                      ref: "multipleTable",
                      staticClass: "goods-attribute-table-draggable-20211224",
                      staticStyle: { width: "500px" },
                      attrs: {
                        data: _vm.tableData,
                        stripe: "",
                        border: "",
                        "header-cell-style": _vm.$rowStyle.DEFAULT,
                        "row-key": "BJ_EBC_ID",
                        "row-class-name":
                          "goods-attribute-tr-draggable-20211224",
                      },
                      on: { "selection-change": _vm.handleSelectionChange },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "selection",
                          width: "55",
                          align: "center",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "value",
                          label: _vm.$t("goodsClassify.table.Attributevalue"),
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c("BjInput", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isEditRow(props.row),
                                        expression: "isEditRow(props.row)",
                                      },
                                    ],
                                    attrs: {
                                      maxlength: _vm.MAX_LENGTH.DEFAULT,
                                    },
                                    model: {
                                      value: props.row.value,
                                      callback: function ($$v) {
                                        _vm.$set(props.row, "value", $$v)
                                      },
                                      expression: "props.row.value",
                                    },
                                  }),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.isEditRow(props.row),
                                          expression: "!isEditRow(props.row)",
                                        },
                                      ],
                                    },
                                    [_vm._v(_vm._s(props.row.value))]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4188376741
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("table.operationText"),
                          width: "100",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.isEditRow(props.row),
                                          expression: "!isEditRow(props.row)",
                                        },
                                      ],
                                      staticClass: "edit-btn",
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onEdit(
                                            props.row,
                                            props.$index
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("editText")))]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.isEditRow(props.row),
                                          expression: "isEditRow(props.row)",
                                        },
                                      ],
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onCancel(
                                            props.row,
                                            props.$index
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("cancelText")))]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.isEditRow(props.row),
                                          expression: "isEditRow(props.row)",
                                        },
                                      ],
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onSave(
                                            props.row,
                                            props.$index
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("saveText")))]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.isEditRow(props.row),
                                          expression: "!isEditRow(props.row)",
                                        },
                                      ],
                                      staticClass: "delete-btn",
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onDel(
                                            props.row,
                                            props.$index
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("delText")))]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1185513813
                        ),
                      }),
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            label: _vm.$t("goodsClassify.table.DragSort"),
                            width: "100",
                            align: "center",
                            "class-name": "draggableItem",
                          },
                        },
                        [
                          [
                            _c("svg-icon", {
                              attrs: { "icon-class": "pointer" },
                            }),
                          ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("BjDivider", [_vm._v(_vm._s(_vm.$t("operationText")))]),
              _c(
                "span",
                {
                  staticClass: "footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v(_vm._s(_vm.$t("cancelText"))),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.handleConfirm("form")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("okText")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }